export const forms = (() => {
    let dpn = document.querySelector('[data-page-note]');
    if (!dpn) return;

    let cGuidId = dpn.getAttribute("data-page-note");
    if (!cGuidId) return;


    let editBtn = document.getElementsByClassName("pagetools-tool")[0];
    let form = document.getElementById("notes-form");
   

    checkIfNoted(cGuidId);

    form.addEventListener("submit", function (e) {
        e.preventDefault();
        savePageNote(cGuidId);
    })



    function savePageNote(cGuidId) {
        var data = new FormData();
        let status = document.getElementById("notes-status");
        let sButton = document.querySelector(".notes-button");

        data.append("note", document.getElementById("notes-textarea").value);
        data.append("contentGuid", cGuidId);
        status.innerText = "Sparar...";
        status.classList.remove("notes-status-hidden");
        sButton.setAttribute("disabled", "disabled");

        fetch("/PageNote/SavePageNote/", {
            method: "POST",
            body: data,
            cache: 'no-store'
        })
            .then((result) => {
                console.log("result: " + result);
                sButton.removeAttribute("disabled");
                if (result.status != 200) {
                    status.innerText = "Något gick på tok. Var god försök igen";
                    throw new Error("Bad Server Response");
                }
                return result.text();
            })
            .then((response) => {
                status.innerText = "Anteckningen är sparad";

                
                setTimeout(function () {
                    status.classList.add("notes-status-hidden");
                }, 2000);

                document.getElementById("notes-textarea").value = response;
                editBtn.classList.add("pagetools-tool-active");
                document.getElementsByClassName("pagetools-toolText")[0].innerText = "Mina anteckningar"

            })
            .catch((error) => {
                console.log(error);
                status.innerText = "Något gick på tok. Var god försök igen. [ERROR:Bad Server Response]";
                throw new Error("Bad Server Response");
            });

    };


    function checkIfNoted(cGuidId) {
        const data = new URLSearchParams();
        data.append('contentGuid', cGuidId);

        fetch('/PageNote/IsPageNoted/', {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then((result) => {
                if (result.status != 200) { throw new Error("Bad Server Response"); }
                return result.text();
            })
            .then((response) => {
                const result = JSON.parse(response);
                if (result.success) {
                    if (result.pageNoted) {
                        editBtn.classList.add("pagetools-tool-active");
                        document.getElementsByClassName("pagetools-toolText")[0].innerText = "Mina anteckningar"
                        document.getElementById("notes-textarea").value = result.pageNote;
                    } else {
                        editBtn.classList.remove("pagetools-tool-active");
                        document.getElementsByClassName("pagetools-toolText")[0].innerText = "Anteckna"
                    }
                }
            })
            .catch((error) => { console.log(error); });
    };

})();
